import { LI, UL } from "../../../../AbstractElements";
import { Href } from "../../../../Constants/Constants";

const UserProfileIcon = () => {
  return (
    <UL className="share-icons simple-list flex-row">
      <LI>
        <a className="social-icon bg-primary" href={Href}>
          <i className="fa fa-smile-o" />
        </a>
      </LI>
      <LI>
        <a className="social-icon bg-secondary" href={Href}>
          <i className="fa fa-wechat" />
        </a>
      </LI>
      <LI>
        <a className="social-icon bg-warning" href={Href}>
          <i className="fa fa-share-alt" />
        </a>
      </LI>
    </UL>
  );
};

export default UserProfileIcon;
